export default {
notification: {
  read: "Read",
  unread: "Unread",
  hide: "Hide",
  showAll: "Show All",
  loading: "Loading...",
  noMore: "No more data",
  platform: "Platform",
  personal: "Personal"
}
};
